import { t } from "i18next";
import { StatusTagColor } from "../../../deprecated/StatusTag/StatusTag";

export type Color = {
  [key in StatusTagColor]: string;
};

export const statusBackgroundColorMapping: Color = {
  blue: "#e6f7ff",
  green: "#f6ffed",
  grey: "#fafafa",
  orange: "#fff7e6",
  red: "#ffccd4",
  yellow: "#fffaeb",
  blueLight: "#f0f9ff",
  indigo: "#eef4ff",
  purple: "#f4f3ff",
  pink: "#fdf2fa",
  greyBlue: "#f8f9fc",
};

export const statusBorderColorMapping: Color = {
  blue: "#91d5ff",
  green: "#b7eb8f",
  grey: "#eaecf0",
  orange: "#ffd591",
  red: "#ffccd4",
  yellow: "#fedf89",
  blueLight: "#b9e6fe",
  indigo: "#c7d7fe",
  purple: "#d9d6fe",
  pink: "#fcceee",
  greyBlue: "#d5d9eb",
};

export type ColorOption = {
  label: string;
  value: string;
};

export const colorOptions = (): ColorOption[] =>
  Object.entries(statusBackgroundColorMapping).map(([color, value]) => ({
    label: t(`main.color_options.${color}`),
    value: color,
  }));
